import { SET_LOCATOR_ERRORS, SENDING_LOCATOR } from '../../../types/conversations/plugins'

const initLocatorsState = {
  type: 'flight',
  price: 0,
  rows: [
    {
      airline: '',
      locator: '',
    },
  ],
  errors: {},
}

export default function locators(state = initLocatorsState, action) {
  switch (action.type) {
    case SENDING_LOCATOR: {
      const { sendingLocator } = action
      return Object.assign({}, state, { sendingLocator })
    }
    case SET_LOCATOR_ERRORS: {
      const { errors } = action
      return Object.assign({}, state, { errors })
    }
    default: {
      return state
    }
  }
}
